import {googleRatingConstants} from "../../../../constants/General/googleRating.constants";

const initialState = {
    fetching: false,
    data: null,
    error: false,
};

export default function (state = initialState, action) {
    switch (action.type) {

        case googleRatingConstants.GOOGLE_RATING_GET_PENDING:
            return {
                ...state,
                fetching: true,
                data: null,
                error: false,
            };
        case googleRatingConstants.GOOGLE_RATING_GET_FULFILLED:
            return {
                ...state,
                fetching: false,
                error: false,
                data: action.payload,
            };
        case googleRatingConstants.GOOGLE_RATING_GET_REJECTED:
            return {
                ...state,
                fetching: false,
                error: action.payload,
            };

        case googleRatingConstants.GOOGLE_RATING_CLEAR:
            return {
                ...initialState,
            };
        case "CLEAR_STATE":
            return {
                ...initialState,
            };
        default:
            return state;
    }
}
